import { createApiConfigurationSeed } from 'app/src/msw/companyagreement/initialSeed/apiConfiguration'
import { createCategoryCollectionSeeds } from 'app/src/msw/companyagreement/initialSeed/categories'
import { createProductsCollectionSeeds } from 'app/src/msw/companyagreement/initialSeed/products'

export const createAllCompanyAgreementSeeds = async () => {
  await createCategoryCollectionSeeds()
  await createProductsCollectionSeeds()
  await createApiConfigurationSeed()
}
